<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular"
>
  <div
    class="form-field-label {{type}}"
    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="outline"
    class="form-field w-full"
    [ngClass]="type ? 'small' : ''"
    hideRequiredMarker
  >
    <input
      #input
      class="input {{type}} date-input"
      [formControlName]="controlName"
      [matDatetimepicker]="dts"
      [required]="isRequired"
      autocomplete="false"
      placeholder="{{placeholder}}"
      [max]="max"
      [min]="min"
      matInput
    >
    <mat-icon matPrefix matRipple svgIcon="calender"></mat-icon>
    <mat-datetimepicker #dts [openOnFocus]="true" [timeInterval]="5" type="datetime"></mat-datetimepicker>
    <mat-error *ngIf="error">{{error}}</mat-error>
  </mat-form-field>
</div>
